import { takeLatest } from 'redux-saga/effects';
import { collectionRequestEffect, collectionRequestOnMobileEffect } from 'common/sagas/effects';
import { COLLECTION_REQUEST, COLLECTION_REQUEST_MOBILE } from 'common/actions/collection';

export const channelsSaga = function* () {
  yield takeLatest(COLLECTION_REQUEST, collectionRequestEffect);
  yield takeLatest(COLLECTION_REQUEST_MOBILE, collectionRequestOnMobileEffect);
};
